import { IState } from "../../reducers";
import { IMyPortfolioEngagementListState } from "./my-portfolio-engagement-list.reducer";
import { IEngagementList } from "../../../common/services/contracts/portfolio.model";

export const getMyPortfolioEngagementListState = (store: IState): IMyPortfolioEngagementListState => store.engagementList;
export const getMyPortfolioEngagementList = (store: IState): IEngagementList[] => getMyPortfolioEngagementListState(store).engagementList;
export const getMyPortfolioEngagementListLoading = (store: IState): boolean => getMyPortfolioEngagementListState(store).loading;
export const getMyPortfolioEngagementListLoaded = (store: IState): boolean => getMyPortfolioEngagementListState(store).loaded;
export const getMyPortfolioEngagementListError = (store: IState): string => getMyPortfolioEngagementListState(store).error;
